import React, {useState, useContext} from 'react';
import "../Styles.css";
import ChangePassword from '../../common/ChangePassword';

import "../../../ui-styles/tabStyles/HztlTabStyles.css";
import "../../../ui-styles/contentHeading/contentHeading.css";
import {LangCtx} from "../../../lib/context";

const ClinicSettings = (props) => {
    const [current, setTab] = useState("CP");
    const {l} = useContext(LangCtx);

    return(
        <div className="baseContainer">
            <div className="hdngTopCol colBlock">
                <div className="hdngTopBox etcPdng">
                    <h2 className="topHdngTxt">{l.settings}</h2>
                </div>
                <div className="tabCol">
                    <div className="row hndlpdn08">
                        <div className={current === "CP" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"} onClick={(e) => setTab("CP")}>
                            <span>{l.change_pwd}</span>
                        </div>
                    </div>
                </div>
            </div>
            {current === "CP" && <ChangePassword />}
        </div>
    )
}

export default ClinicSettings;